var exports = {
  "hX": "x61f99309--da0319--offer-message__bubble",
  "xT": "x61f99309--da0319--offer-message__quote",
  "w7": "x61f99309--da0319--offer-message__meta",
};

module.exports = exports;
